import { render, staticRenderFns } from "./InserirDocumentos.vue?vue&type=template&id=01f13a92"
import script from "./InserirDocumentos.vue?vue&type=script&lang=js"
export * from "./InserirDocumentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports